export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-enlarged-700px.6f54936c.jpg";